export default {"src":"/_next/static/media/receipt-list.5cb65368.svg","height":16,"width":16};